import {RootState} from '../rootReducer';
import {createSelector} from '@reduxjs/toolkit';

export const authStatus = createSelector(
  [(state: RootState) => state.auth.isAuthenticated],
  isAuthenticated => isAuthenticated,
);

export const isAuthLoading = createSelector(
  [(state: RootState) => state.auth.isLoading],
  isLoading => isLoading,
);

export const authSuccessStatus = createSelector(
  [(state: RootState) => state.auth.authSuccess],
  authSuccess => authSuccess,
);

export const authFailureStatus = createSelector(
  [(state: RootState) => state.auth.authFailure],
  authFailure => authFailure,
);

export const authDataSelector = createSelector(
  [(state: RootState) => state.auth.authData],
  authData => authData,
);

export const otpAttemptsSelector = createSelector(
  [(state: RootState) => state.auth.otp_attempts],
  attempts => attempts,
);

export const otpTimerSelector = createSelector(
  [(state: RootState) => state.auth.otpTimer],
  otpTimer => otpTimer,
);

export const canChangeEmailSelector = createSelector(
  [(state: RootState) => state.auth.persist?.canChangeEmail],
  canChangeEmail => canChangeEmail,
);

export const canChangePhoneSelector = createSelector(
  [(state: RootState) => state.auth.persist?.canChangePhone],
  canChangePhone => canChangePhone,
);

export const emailOtpTimerSelector = createSelector(
  [(state: RootState) => state.auth.persist?.email_otp_timer],
  emailOtpTimer => emailOtpTimer,
);

export const phoneOtpTimerSelector = createSelector(
  [(state: RootState) => state.auth.persist?.phone_otp_timer],
  phoneOtpTimer => phoneOtpTimer,
);

export const emailOtpAttemptsSelector = createSelector(
  [(state: RootState) => state.auth.persist?.email_otp_attempts],
  emailOtpAttempts => emailOtpAttempts,
);

export const phoneOtpAttemptsSelector = createSelector(
  [(state: RootState) => state.auth.persist?.phone_otp_attempts],
  phoneOtpAttempts => phoneOtpAttempts,
);


export const accountDeletionStatusSelector = createSelector(
  [(state: RootState) => state.auth.accountDeletionStatus],
  accountDeletionStatus => accountDeletionStatus,
);

export const accountExportStatusSelector = createSelector(
  [(state: RootState) => state.auth.accountExportStatus],
  accountExportStatus => accountExportStatus,
);

export const isAccountDeletionLoadingSelector = createSelector(
  [(state: RootState) => state.auth.isAccountDeletionLoading],
  isAccountDeletionLoading => isAccountDeletionLoading,
);

export const isAccountExportLoadingSelector = createSelector(
  [(state: RootState) => state.auth.isAccountExportLoading],
  isAccountExportLoading => isAccountExportLoading,
);

export const authSessionSelector = createSelector(
  [(state: RootState) => state.auth.authSession],
  authSession => authSession,
);

export const isProfileUpdateLoadingSelector = createSelector(
  [(state: RootState) => state.auth.profileupdateLoading],
  profileupdateLoading => profileupdateLoading,
);

export const isPhoneVerifyLoadingSelector = createSelector(
  [(state: RootState) => state.auth.phoneVerifyLoading],
  phoneVerifyLoading => phoneVerifyLoading,
);

export const isEmailVerifyLoadingSelector = createSelector(
  [(state: RootState) => state.auth.emailVerifyLoading],
  emailVerifyLoading => emailVerifyLoading,
);